import React from 'react';
import style from './Home.module.css';
import HomePrimaryCTA from '../../Components/Buttons/HomePrimaryCTA/HomePrimaryCTA';
import HomeSecondaryCTA from '../../Components/Buttons/HomeSecondaryCTA/HomeSecondaryCTA';
import { Link } from 'react-scroll';


const Home = (props) => {
	return (
		<section className={style.Home} id='home'>
			<section className={style.Introduction}>
				<div className={style.IntroductionContainer}>
					<div className={style.IntroductionText} data-reveal="up">
						<article className={style.NameIntroduction}>
							Emmanuel A. Bello
						</article>

						<span className={style.WorkTitle} data-reveal="up" data-reveal-delay="80">Senior Software Engineer. Founder. Inventor.</span>

						<article className={style.ProfessionalSummary} data-reveal="up" data-reveal-delay="160">
							Software Engineer with a decade of experience, Project Lead and Independent Researcher at Project Kinetic. My experience working with brands and startups accross multiple fields around the globe combined with my actively curious and experimental nature gives me unique & valuable insights and expertise.
							<p />
							Received multiple software certifications. Educational background in Quantity Surveying and Construction Cost Management. Working towards more (details soon).

							<p />
							3x ETHGlobal hackathon prize winner. Building Calcium - Stryd (Microsoft Startups Partner) and Project Kinetic (NullNet, Kinetic Keys, Null Wallet and beyond).
							<p />
							In my free time, I play video games, read books and goof around with my various hobbies and buddies.
						</article>
					</div>

					<div className={style.Buttons} data-reveal="up" data-reveal-delay="260">
						<Link to='portfolio' smooth='true'>
							<HomePrimaryCTA text='My Work' />
						</Link>

						<Link to='contact' smooth='true'>
							<HomeSecondaryCTA text='Contact Me' />
						</Link>
					</div>
				</div>
			</section>
		</section>
	)
}
export default Home;